
(function ( $ ) {

    $.fn.noteable = function(options, args) {

        if (typeof options === 'string') {
            return _callFn(this, options, params);
        }

        // do not recontruct if its constructed
        if (this.hasClass('-noteabled')) return this;

        // This is the easiest way to have default options.
        var settings = $.extend({
            // These are the defaults.

        }, options);

        // store settings
        this.data('_noteable', settings);

        // lets get started
        uiInit(this);

        // lets get started
        // if we don't have a valid timeline_id, change state
        if (this.data('parentType') == '' || this.data('parentId') == '') {
            paneState(this, 'empty');

        // otherwise, lets start the party
        } else
            load(this);

        // mark as 'gridified' and return for chaining
        return this.addClass('-noteabled');
    };

    function load ($this) {

        // set state
        paneState($this, 'loading');

        // empty existing notes
        $this.find('.chat').empty();

        if (!$this.data('parentType') || !$this.data('parentId')) {
            return;
        }

        var success = function (json) {
            if (json.length === 0)
                paneState($this, 'empty');

            else {
                paneState($this, 'active');
                populate($this, json);
            }
        };

        var error = function (response) {
            paneState($this, 'empty');
            if (typeof toastr !== 'undefined') toastr.error('Failed to load notes.<br>' + response.responseJSON.error.message);
        };

        const filter = $this.find('.noteable-filter').val();
        let route = '/api/notes/'+$this.data('parentType')+'/'+$this.data('parentId');

        if (filter) {
            route += '?type=' + filter
        };

        $.ajax({
            type     : 'get',
            url      : route,
            success  : success,
            error    : error,
            dataType : 'json'
        });
    }

    function uiInit ($this) {

        // draw main ui
        $this.append($(htmlMain()));

        // default state
        paneState($this, 'loading');

        // event listeners
        $this.find('.noteable-new').bind('click', function(ev){ ev.preventDefault(); modalNew($this); });
        $this.find('.noteable-filter').bind('change', function(){ load($this); });
        $this.find('.noteable-reload').bind('click', function(ev){ ev.preventDefault(); load($this); });
        $('#noteable-form').bind('submit', function(ev) { ev.preventDefault(); modalSave($this); });
    }

    function modalNew ($this) {
        $modal = $('#noteable-modal');
        $modal.find('input[name=id]').val('');
        $modal.find('input[name=parent_id]').val($this.data('parentId'));
        $modal.find('input[name=parent_type]').val($this.data('parentType'));
        $modal.find('textarea[name=body]').val('');
        $modal.find('input[name=due_at]').val('');
        $modal.find('input[name=completed_at]').val('');
        $modal.find('.urls-selectize')[0].selectize.items = [];
        $modal.find('.urls-selectize')[0].selectize.refreshItems();

        $modal.find('.noteable-delete').addClass('hide');

        $modal.on('shown.bs.modal', function() {
            $modal.find('textarea').focus();
        });
        $modal.modal();
    }

    function modalEdit ($this, note) {
        $modal = $('#noteable-modal');

        $modal.find('.noteable-delete').removeClass('hide').unbind('click').on('click', function(ev){
            ev.preventDefault();
            modalDelete($this, note);
        });

        $modal.find('input[name=id]').val(note.id);
        $modal.find('input[name=parent_id]').val(note.parent_id);
        $modal.find('input[name=parent_type]').val(note.parent_type);
        $modal.find('textarea[name=body]').val(note.body);
        $modal.find('input[name=due_at]').val(note.due_formatted);
        $modal.find('input[name=completed_at]').val(note.completed_formatted);

        selectize = $modal.find('.urls-selectize')[0].selectize;
        selectize.clear();
        if (note.urls) {
            $.each(note.urls, function(i, url){
                selectize.addOption({'text':url, 'value':url});
                selectize.addItem(url);
            });
        }

        $modal.on('shown.bs.modal', function() {
            $modal.find('textarea').focus();
        });
        $modal.modal();
    }

    function modalDelete ($this, note) {
        $modal = $('#noteable-modal');

        if (!confirm('Are you sure you want to delete this note?'))
            return;

        $modal.modal('hide');
        paneState($this, 'loading');

        var success = function () {
            if (typeof toastr !== 'undefined') toastr.success('Note deleted!');
        };

        var error = function (response) {
            if (typeof toastr !== 'undefined') toastr.error('Failed to delete note.<br>' + response.responseJSON.error.message);
        };

        $.ajax({
            type     : 'post',
            url      : '/api/notes/'+note.id+'/delete',
            data     : {'_token':$modal.find('input[name=_token]').val()},
            success  : success,
            error    : error,
            dataType : 'json'
        }).always(function(){
            load($this);
        });
    }

    function modalSave ($this) {
        $form = $('#noteable-form');
        $modal = $('#noteable-modal');

        var success = function () {
            if (typeof toastr !== 'undefined') toastr.success('Note saved!');
        };

        var error = function (response) {
            if (typeof toastr !== 'undefined') toastr.error('Failed to save note.<br>' + response.responseJSON.error.message);
        };

        $.ajax({
            type     : 'post',
            url      : '/api/notes/' + ( ($form.find('input[name=id]').val()) ? $form.find('input[name=id]').val() + '/edit' : $this.data('parentType')+'/'+$this.data('parentId')+'/add'),
            data     : $form.serializeArray(),
            success  : success,
            error    : error,
            dataType : 'json'
        }).always(function(){
            $modal.modal('hide');
            load($this);
        });
    }

    function paneState ($this, state) {

        if (state === 'loading') {
            $this.find('.noteable-scroll-pane').addClass('hide');
            $this.find('.noteable-status').removeClass('hide')
                .html('<i class="fa fa-circle-o-notch fa-5x fa-spin"></i>');

        } else if (state === 'empty') {
            $this.find('.noteable-scroll-pane').addClass('hide');
            $this.find('.noteable-status').removeClass('hide')
                .html('<i class="fa fa-frown-o fa-5x"></i><br>No notes');

        } else if (state === 'active') {
            $this.find('.noteable-scroll-pane').removeClass('hide');
            $this.find('.noteable-status').addClass('hide');
        }
    }

    function htmlMain () {
        return '<div class="chat-panel panel panel-default">' +
            '<div class="panel-heading">' +
                '<i class="fa fa-comments fa-fw"></i>' +
                'Notes' +
                '<button type="button" class="btn btn-default btn-xs pull-right noteable-reload" data-toggle="dropdown">' +
                    '<i class="fa fa-refresh"></i>' +
                '</button>' +
                '<select class="form-control pull-right noteable-filter">' +
                    '<option value="">(Everything)</option>' +
                    '<option value="activities">Activities</option>' +
                    '<option value="notes" selected>Notes</option>' +
                    '<option value="subscription_changes">Subscription changes</option>' +
                '</select>' +
            '</div>' +
            '<div class="panel-body">' +
                '<div class="noteable-status hide"></div>' +
                '<div class="noteable-scroll-pane">' +
                    '<ul class="chat"></ul>' +
                '</div>' +
            '</div>' +
            '<div class="panel-footer">' +
                '<div class="input-group input-sm">' +
                    '<input type="text" class="form-control noteable-new" placeholder="Type your note here..." />' +
                    '<span class="input-group-btn">' +
                        '<button class="btn btn-info noteable-new"><i class="fa fa-send"></i></button>' +
                    '</span>' +
                '</div>' +
            '</div>' +
        '</div>';
    }

    function htmlNote (note) {
        const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone
        const utcDate = new Date(note.created_at)
        const localDate = utcDate.toLocaleDateString('en-US', { timeZone, year: 'numeric', month: 'short', day: 'numeric' })
        const localTime = utcDate.toLocaleTimeString('en-US', { timeZone, hour: '2-digit', minute: '2-digit' })

        const message = note.type === 'activities' && note.body?.includes('<body')
            ? '<a href="/notes/'+note.id+'/view" target="_blank"><i class="fa fa-envelope-o"></i> View Message</a>'
            : forHtml(note.body)

        return '<li class="left clearfix">' + // use RIGHT when user_id = user->id
            '<span class="chat-img pull-left">' +
                '<img src="'+note.created_by.gravatar_url+'" width="32" height="32" alt="User Avatar" class="rounded-full border border-gray-400" />' +
            '</span>' +
            '<div class="chat-body clearfix">' +
                '<div class="header">' +
                    '<strong class="primary-font">'+note.created_by.full_name+'</strong>' +
                    ( (note.is_overdue) ? ' <span class="label label-danger">'+note.due_for_humans+'</span>' : '') +
                    ( (note.is_complete) ? ' <small class="text-muted"><i class="fa fa-check"></i> Complete</small>' : '') +
                    ( (note.is_due && !note.is_overdue) ? ' <span class="label label-warning">'+note.due_for_humans+'</span>' : '') +
                    '<small class="pull-right text-muted noteable-tooltip">' +
                        '<i class="fa fa-clock-o fa-fw"></i> ' + note.created_for_humans +
                        '<span class="noteable-tooltip-text">' + localDate + ' ' + localTime + '</span>' +
                    '</small>' +
                '</div>' +
                '<div class="noteable-message">'+ message +'</div>' +
                '<div class="noteable-links"></div>' +
            '</div>' +
        '</li>';
    }

    function populate ($this, notes) {
        $.each(notes, function(i, note){
            drawNote($this, note, i);
        });
    }

    function drawNote ($this, note, ix) {
        const filter = $this.find('.noteable-filter').val();
        const shouldBeFiltered = filter && note.type !== filter;

        if (shouldBeFiltered) {
            return;
        }

        // html template
        $el = $(htmlNote(note)).appendTo($this.find('.chat'));

        if (note.urls) {
            $.each(note.urls, function(i, url){
                $el.find('.noteable-links').append($('<a class="btn btn-default" href="'+_.escape(url)+'" target="_blank"><i class="fa fa-link"></i> '+detectUrlLabel(url)+'</a>'));
            });
        }

        // only allow editting if it's actually a note
        if (note.type === 'notes') {
            $el.find('.noteable-message, .chat-body .header, .chat-img').on('click', function(ev){
                ev.preventDefault();
                modalEdit($this, note);
            });
        }
    }

    function detectUrlLabel (url) {
        if (url.indexOf('github') >= 0) {
            return 'Git';
        } else if (url.indexOf('groovehq') >= 0) {
            return 'Groove Ticket';
        }

        var domain;

        //find & remove protocol (http, ftp, etc.) and get domain
        if (url.indexOf("://") > -1) {
            domain = url.split('/')[2];
        }
        else {
            domain = url.split('/')[0];
        }

        //find & remove port number
        domain = domain.split(':')[0];

        return _.escape(domain);
    }

    function forHtml (str) {

        var cleaned = filterXSS(str, {
            whiteList: {
                p: [],
                b: [],
                i: [],
                a: ['href', 'title', 'class', 'style'],
                img: ['src', 'alt', 'title', 'class', 'style'],
                span: ['class', 'style'],
            },
            stripIgnoreTag: true,
            stripIgnoreTagBody: ['script'],
        });

        return cleaned.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    // used to route function calls
    function _callFn ($this, fn, args) {
        switch (fn) {
            //case 'resize': return __resize($this, params);
        }
    }
}( jQuery ));
